import styled from 'styled-components';

import Select from '../../../../../../../../components/Select';

const SelectorContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const ProductSelect = styled(Select)`
  min-width: unset;

  .MuiSelect-select {
    font-size: 14px;
  }
`;

export {
  SelectorContainer,
  ProductSelect,
};
